module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{},"en":{},"nl":{}}')
  delete Component.options._Ctor
}
